// extracted by mini-css-extract-plugin
export default {"rating":"CL-z","numberOfStars":"DL-z","count":"EL-z","barGraphSpacing":"FL-z","barGraph":"GL-z"};